import { PUBLIC_ENVIRONMENT } from "$env/static/public";
import type { ParamMatcher } from "@sveltejs/kit";

/** /API is run by ASP.NET Core, not SvelteKit */
export const match = ((param) => {
	if (PUBLIC_ENVIRONMENT === "Development") return true;
	return !param.startsWith("API");
}) satisfies ParamMatcher;
